import { useState } from "react";
import { Play } from "lucide-react";
import thumbnailImg from "@/assets/photo-video-thumbnail.jpg";

export default function VideoShowcase() {
  const [videoPlaying, setVideoPlaying] = useState(false);

  return (
    <div className="relative -mt-1">
      {/* Top half: matches hero overlay (charcoal base + 70% overlay = same tint) */}
      <div className="absolute top-0 left-0 right-0 h-1/2 bg-charcoal" style={{ clipPath: "polygon(0 0, 100% 0, 100% 70%, 0 100%)" }} />

      {/* Bottom half: light background */}
      <div className="absolute bottom-0 left-0 right-0 h-1/2 bg-background" />

      {/* Content — circle straddles both halves */}
      <div className="relative z-10 flex flex-col items-center pt-8 pb-12">
        {/* Video circle */}
        <div className="relative" style={{ width: "fit-content" }}>
          {/* Animated gold swirl border */}
          <div
            className="absolute -inset-4 rounded-full animate-spin"
            style={{
              background: "conic-gradient(from 0deg, hsl(var(--gold)) 0%, transparent 20%, hsl(var(--gold) / 0.4) 40%, transparent 60%, hsl(var(--gold) / 0.2) 80%, hsl(var(--gold)) 100%)",
              filter: "blur(4px)",
              animationDuration: "8s",
            }}
          />
          <div className="absolute -inset-2 rounded-full border-2 border-gold/40" />

            <div className="relative w-72 h-72 sm:w-[26rem] sm:h-[26rem] rounded-full overflow-hidden shadow-2xl border-4 border-gold/60">
            {videoPlaying ? (
              <iframe
                src="https://www.youtube.com/embed/KWgA3frK8c0?autoplay=1&rel=0&modestbranding=1"
                title="Présentation CrossFit Chistera"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="absolute inset-0 w-full h-full"
                style={{ borderRadius: "50%", border: "none" }}
              />
            ) : (
              <button
                onClick={() => setVideoPlaying(true)}
                className="w-full h-full relative group cursor-pointer"
                aria-label="Lancer la vidéo"
              >
                <img
                  src={thumbnailImg}
                  alt="Vidéo de présentation CrossFit Chistera — visite de la box à Saint-Pierre-de-Chandieu"
                  width={720}
                  height={819}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-charcoal/30 group-hover:bg-charcoal/10 transition-colors flex items-center justify-center">
                  <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-gold flex items-center justify-center group-hover:scale-110 transition-transform shadow-[0_0_30px_hsl(var(--gold)/0.5)]">
                    <Play className="text-charcoal ml-1" size={40} fill="currentColor" />
                  </div>
                </div>
                {/* Text overlay — gradient fade at bottom of circle */}
                <div className="absolute bottom-0 left-0 right-0 pointer-events-none">
                  <div className="pt-16 pb-8 sm:pb-10 px-4 text-center" style={{ background: "linear-gradient(to bottom, transparent 0%, rgba(27,23,24,0.78) 40%, rgba(27,23,24,0.95) 100%)" }}>
                    <h2 className="text-lg sm:text-xl text-white font-heading leading-tight drop-shadow-md">Découvrez notre box</h2>
                    <p className="text-white font-body normal-case text-xs sm:text-sm drop-shadow-md leading-tight">Une visite en images de<br />CrossFit Chistera</p>
                  </div>
                </div>
              </button>
            )}
          </div>
        </div>

        {/* Text below video — removed, now on circle */}

        {/* Design separator */}
        <div className="mt-10 flex flex-col items-center gap-1">
          <div className="w-px h-8 bg-gradient-to-b from-transparent via-gold/60 to-gold" />
          <div className="w-2.5 h-2.5 rotate-45 border-r-2 border-b-2 border-gold" />
          <div className="w-px h-8 bg-gradient-to-b from-gold to-transparent" />
        </div>
      </div>
    </div>
  );
}
